/**
 * Transforms a Figma URL into an embed URL
 * @param {string} figmaUrl - The original Figma URL
 * @returns {string|null} - The embed URL or null if invalid
 */
export function getFigmaEmbedUrl(figmaUrl) {
  if (!figmaUrl || typeof figmaUrl !== 'string') {
    return null;
  }

  // Check if URL is already an embed URL
  if (figmaUrl.includes('https://www.figma.com/embed')) {
    return figmaUrl;
  }

  // Validate URL format
  try {
    const url = new URL(figmaUrl);
    
    // Must be HTTPS
    if (url.protocol !== 'https:') {
      return null;
    }

    // Must contain figma.com
    if (!url.hostname.includes('figma.com')) {
      return null;
    }

    // Create embed URL
    return `https://www.figma.com/embed?embed_host=share&url=${encodeURIComponent(figmaUrl)}`;
  } catch (error) {
    // Invalid URL format
    return null;
  }
}

/**
 * Validates if a URL is a valid Figma URL
 * @param {string} url - The URL to validate
 * @returns {boolean} - True if valid Figma URL
 */
export function isValidFigmaUrl(url) {
  if (!url || typeof url !== 'string') {
    return false;
  }

  try {
    const urlObj = new URL(url);
    return urlObj.protocol === 'https:' && urlObj.hostname.includes('figma.com');
  } catch (error) {
    return false;
  }
}
